import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const TYNotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ActionHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

const InfoHeader = styled.div``;

const InitialPreview = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--radius-m);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 682px;
  padding-top: 10%;
  width: 500px;

  ${Typography.S.Typography} {
    margin-top: 16px;
  }
`;

const MessageCardWrapper = styled.div`
  min-height: 682px;
  width: 500px;

  .card-header {
    display: flex;
    justify-content: space-between;
  }
  .card-wrapper {
    height: 100%;
    padding: 24px;
  }
`;

const RecipientName = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  max-width: 150px;
  overflow: overlay;
`;

const TableContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
`;

export {
  ActionHeader,
  InfoHeader,
  InitialPreview,
  MessageCardWrapper,
  RecipientName,
  TYNotesWrapper,
  TableContainer
};
